import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModuleV1Read } from '../models/module-v1-read.model';
import { ModuleUpdateInPlace } from '../models/module-update-in-place.model';

@Injectable()
export class ModulesAdminV1Service {
    constructor(private http: HttpClient) {}

    updateLatestPublicVersion(moduleId: string, moduleUpdateInPlaceModel: ModuleUpdateInPlace): Observable<ModuleV1Read> {
        return this.http.patch<ModuleV1Read>(`/api/module_manager/v1/admin/modules/${moduleId}/versions/latestPublic`, moduleUpdateInPlaceModel);
    }
}
